import anime from 'animejs';
import _map from 'lodash/map';
import _debounce from 'lodash/debounce';
import * as pixi from 'pixi.js';
import React, { Component, PureComponent } from 'react';
import { Blobber } from 'src/components/blobber/Blobber';
import './WhereSlide2.scss';
import { randomRange } from 'src/utils/random';
import { wobblyLineProps } from 'src/pages/slide';
import ReactSVG from 'react-svg';
import { analyticsService } from "src/services/AnalyticsService";

const MAX_CIRCLE_RADIUS = 310;
const offsetBlob = -300;
const CIRCLE_UNFOCUSED_RADIUS = 30;
const MODE_NORMAL = 'normal';
const MODE_ACTIVE = 'active';
const MODE_HIDDEN = 'hidden';
const DESKTOP_BP = 760;

export class WhereSlide2 extends Component {
  app = null;
  circles = [
    { color: 0x960528, fillColor: 0x791029, hoverStrokeColor: 0xcc8195, hoverFillColor: 0x8a505c, radius: 280, label: 'Our world', id: 'world',
      content: <>
        <p><b>Our world</b> is dealing with systemic problems that require innovation.</p>
        <p>From <b>transport</b> to <b>climate change</b>, our greatest on-going battles are being fought with an approach to problem solving that calls for us to evaluate these problem and try out many different solutions, not just to accept the commonly held beliefs of our predecessors.</p>
      </>
    },
    { color: 0xBE0028, fillColor: 0xa90528, hoverStrokeColor: 0xdc8395, hoverFillColor: 0xab485d, radius: 220, label: 'Our communities', id: 'community',
      content: <>
        <p><b>Our communities</b> rely on innovative ideas to growth and thrive.</p>
        <p><b>Entrepreneurs</b> know that the best way to have good ideas is to have lots of ideas, test them, and improve them steadily.</p>
      </>
    },
    { color: 0xDC0032, fillColor: 0xcc012f, hoverStrokeColor: 0xFF8FA8, hoverFillColor: 0xc84362, radius: 160, label: 'Absa as a whole', id: 'company',
      content: <>
        <p><b>Absa</b> is a large business with many many humans working hard to deliver value to the customer.</p>
        <p>It’s incredibly important that we all push ourselves to be brave - to fail and to let others fail in trying new things.</p>
        <p>Failure must be part of the process. Without experimentation (taking risks), we cannot change.</p>
      </>
    },
    { color: 0xF52D28, fillColor: 0xe81f2a, hoverStrokeColor: 0xff9094, hoverFillColor: 0xdf5360, radius: 110, label: 'Your vertical', id: 'vertical',
      content: <>
        <p><b>Your vertical</b> relies on many internal processes and procedures that ensure business runs smoothly.</p>
        <p>These processes are never perfect, and need constant improvement and maintenance.</p>
        <p>It’s up to every Absa colleague to ensure that improvement is made through the 4 step process outlined below.</p>
      </>
    },
    { color: 0xFA551E, fillColor: 0xf54522, hoverStrokeColor: 0xfea386, hoverFillColor: 0xed695c, radius: 60, label: 'Your team', id: 'team',
      content: <>
        <p>Your team at Absa will likely have some control of the processes and products associated with your broader department.</p>
        <p>It’s up to the team to ensure that the highest standards are met as quickly as possible.</p>
        <p>To achieve this, we take the brave step of trying new things, learning from - failure and constantly improving the experience of both our colleagues and our customers.</p>
      </>
    },
    { color: 0xFF780F, fillColor: 0xfc6915, hoverStrokeColor: 0xffbb7f, hoverFillColor: 0xf68253, radius: 30, label: 'You', id: 'you',
      content: <>
        <p><b>You</b> probably already use this approach in your personal life:</p>
        <p>Whenever you have a need, you try different solutions out and try to improve your situation.</p>
        <p>Take for example, the way you travel to work. This may be your routine today, but you had to learn which routes to take, what time to leave, perhaps even which method of transport best suited you.</p>
      </>
    },
  ];
  blobPosition = { x: 0, y: 0 };
  labels = [];
  labelsAnimationFrameId = null;
  blobMoveAnimation = null;
  windowWidth = 0;
  activeLabelTimeout = null;

  constructor() {
    super();
    this.app = new pixi.Application({
      width: 800,
      height: 800,
      antialias: true,
      transparent: true,
      // backgroundColor: 0x490924,
      autoResize: true,
    });

    this.state = {
      activeSection: null,
      labelPositions: [],
      activeLabel: null,
      areLabelsVisible: true,
    };

    this.createBlobs();
    this.createLines();
  }

  createLines() {
    this.labelsLayer = new pixi.Container();
    const labels = _map(this.circles, circle => {
      const line = new pixi.Graphics();
      this.labelsLayer.addChild(line);
      return {
        id: circle.id,
        label: circle.label,
        line,
        position: { x: 0, y: 0 },
        labelPosition: { x: 0, y: 0 },
      };
    });
    this.labels = labels;
    this.app.stage.addChild(this.labelsLayer);
  }

  createLabels() {
    return _map(this.labels, ({ id, label }, i) => {
      let position = this.state.labelPositions[i];
      if (!position) {
        position = { x: 0, y: 0 };
      }
      const style = {
        transform: `translate(${position.x}px, ${position.y}px) translateY(-50%)`,
      };
      const circle = this.circles[i];
      return <div className={`WhereSlide2-labelsItem ${this.state.activeLabel && id !== this.state.activeLabel ? 'WhereSlide2-labelsItem--subdued' : ''}`}
        key={id}
        style={style}
        onClick={e => this.takeOver(i)}
        onMouseEnter={() => this.onHoverOverBlob({ circle })}
        onMouseLeave={() => this.onHoverOutBlob({ circle })}>
          {label}
        </div>
    });
  }

  createBlobs() {
    const x = 400;
    const y = 400;

    _map(this.circles, (circle, i) => {
      const { color, fillColor, radius } = circle;
      const blob = new Blobber({ alpha: 1, color: fillColor, x, y, radius, strokeColor: color });
      blob.useSharedCanvas({ app: this.app });
      blob.makeInteractive({
        onHoverOver: () => this.onHoverOverBlob({ circle }),
        onHoverOut: () => this.onHoverOutBlob({ circle }),
        onClick: () => this.takeOver(i),
      });
      this.resetWobble({ blob, index: i });
      circle.blob = blob;
    });
  }

  resetWobble({ blob, index, useTargets = false }) {
    const { radius } = this.circles[index];
    blob.startWobbling({
      wobble: {
          position: () => ({ min: -10, max: 10 }),
          length: (length) => ({ min: length * .8, max: length * 1.2 }),
          angle: (angle) => ({ min: -Math.PI / 20, max: Math.PI / 20 }),
      },
      getTargets: useTargets ? (anchor) => this.setupAnchorPointAnimationTargets({ mode: MODE_NORMAL, circleRadius: radius, anchor }) : null,
      updated: (blob) => this.onUpdateBlob({ index, blob }),
      timeRange: { min: 700, max: 2500 },
    });
  }

  onHoverOverBlob({ circle }) {
    const { blob } = circle;
    blob.changeColor({ color: circle.hoverFillColor, strokeColor: circle.hoverStrokeColor });
    this.setState({
      activeLabel: circle.id,
    });
  }
  onHoverOutBlob({ circle }) {
    const { blob } = circle;
    blob.changeColor({ color: circle.fillColor, strokeColor: circle.color });

    // prevent label race condition (old label out runs after new label over)
    if (this.state.activeLabel !== circle.id) return;

    this.setState({
      activeLabel: null,
    });
  }


  onUpdateBlob({ index, blob }) {
    if (!this.labels.length || !this.state.areLabelsVisible) return;
    const { anchors, x, y } = blob;
    const { line, position, labelPosition } = this.labels[index];

    // bottom point used for label position
    const point = anchors[1];

    const nextPosition = index === this.labels.length - 1 ? null : this.labels[index + 1].position;
    let offsetStartY = 0;
    if (nextPosition != null) {
      offsetStartY = (nextPosition.y - point.y) / 2;
    }
    else {
      offsetStartY = (anchors[3].y - point.y) / 2;
    }
    line.x = 0;
    line.y = 0;
    const startX = x;
    const startY = y + point.y + offsetStartY;

    let labelX = x + point.original.x + 40;
    let labelY = startY;// + this.circles[index].radius - 20;
    if (nextPosition == null) {
      labelY = y;
    }
    labelY = labelY + (startY - labelY) / 2

    position.x = point.x;
    position.y = point.y;
    labelPosition.x = labelX;
    labelPosition.y = labelY;

    line.clear();
    line.lineStyle(2, 0xffffff, 1);
    line.moveTo(startX + 3, startY);
    line.lineTo(labelX, labelY);
    line.lineStyle(2, 0xffffff, 1);
    line.drawCircle(startX, startY, 4);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();

    this.refs.blobs.appendChild(this.app.view);

    // setTimeout(() => this.takeOver(2), 3000);
    // setTimeout(() => this.resetBlobs(), 3000);
    // document.addEventListener('click', () => this.resetBlobs);

    this.updateLabels();
  }

  componentWillUnmount() {
    _map(this.circles, ({ blob }, i) => {
      blob.destroy();
    });
    this.app.destroy();
    cancelAnimationFrame(this.labelsAnimationFrameId);
    window.removeEventListener('resize', this.onResize);
  }

  updateLabels() {
    this.labelsAnimationFrameId = requestAnimationFrame(() => {
      const labelPositions = _map(this.labels, 'labelPosition');
      this.setState({
        labelPositions,
      });
      this.updateLabels();
    });
  }

  moveBlobs() {
    const el = this.refs.blobs;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    let x = this.state.activeSection != null ? width / 2.5 : width / 4;
    let y = height / 2;

    if (this.windowWidth < DESKTOP_BP && this.state.activeSection !== null) {
      x = 80;
      y = 110;
    }

    if (this.blobMoveAnimation) {
      this.blobMoveAnimation.pause();
    }
    this.blobMoveAnimation = anime({
      targets: this.blobPosition,
      x,
      y,
      duration: 1000,
      easing: 'easeInOutSine',
      update: (anim) => {
        _map(this.circles, ({ blob }, i) => {
          blob.moveTo(this.blobPosition.x, this.blobPosition.y);
        });
      }
    });
  }

  sendAnalytics({ label } = {}) {
    // click back
    if (!label) {
      analyticsService.event({
        category: 'Blob',
        action: 'click-back',
      });

      return;
    }

    analyticsService.event({
      category: 'Blob',
      action: 'click-label',
      label,
    });
  }

  takeOver(index) {
    if (this.state.activeSection != null) {
      this.resetBlobs();
      return;
    }
    const activeSection = index;

    this.app.stage.removeChild(this.labelsLayer);
    this.sendAnalytics({ label: this.circles[activeSection].label });
    _map(this.circles, ({ blob, radius }, i) => {
      const mode = i === index ? MODE_ACTIVE: MODE_HIDDEN;

      if (mode === MODE_HIDDEN) {

        blob.stopWobbling();
        blob.startWobbling({
          wobble: {
            position: () => ({ min: -1, max: 1 }),
            length: (length) => ({ min: 0, max: length * .2 }),
            angle: (angle) => ({ min: -0, max: 0 }),
          },
          getTargets: (anchor) => this.setupAnchorPointAnimationTargets({ mode, anchor, circleRadius: radius }),
          timeRange: { min: 200, max: 1600 },
        });

      }
      else {
        blob.updateWobble({
          getTargets: (anchor) => this.setupAnchorPointAnimationTargets({ mode, anchor, circleRadius: radius }),
        });
      }
    });

    // hide lines, and prevent "jump" when resetting
    _map(this.labels, ({ line }) => {
      line.clear();
    });

    this.setState({
      areLabelsVisible: false,
      activeSection,
    }, () => this.moveBlobs());

      // blob.stopWobbling();
      // blob.startWobbling({
      //   wobble: {
      //       position: () => ({ min: -10, max: 10 }),
      //       length: (length) => ({ min: length * .8, max: length * 1.2 }),
      //       angle: (angle) => ({ min: -Math.PI / 20, max: Math.PI / 20 }),
      //   },
      //   updated: (blob) => this.onUpdateBlob({ index: i, blob }),
      //   timeRange: { min: 200, max: 1500 },
      //   getTargets: (anchor) => this.setupAnchorPointAnimationTargets({ circle: this.circles[i], isActive: index === i, anchor }),
      // });
  }

  resetBlobs() {
    this.sendAnalytics();

    this.app.stage.addChild(this.labelsLayer);

    _map(this.circles, ({ blob }, index) => {
      blob.stopWobbling();
      // blob.updateWobble({
      //   getTargets: null,
      //   timeRange: { min: 700, max: 2500 },
      // });
      this.resetWobble({ blob, index, useTargets: true })
    });

    this.setState({
      areLabelsVisible: true,
      activeSection: null,
    }, () => this.moveBlobs());

  }

  setupAnchorPointAnimationTargets({ mode, anchor, circleRadius }) {
    const TAU = Math.PI * 2;
    const { original, index } = anchor;

    let angle = 0;//(original.angle) % TAU + this.getWobbleAmount('angle', anchor);
    let lengthA = randomRange(10, 100);//this.getWobbleAmount('lengthA', anchor); // randomRange(original.lengthA * .8, original.lengthA * 1.2);
    let lengthB = randomRange(10, 100); //this.getWobbleAmount('lengthB', anchor); // randomRange(original.lengthB * .8, original.lengthB * 1.2);

    let x = original.x;
    let y = original.y;

    let positionOffset = 0;
    let radius = circleRadius;
    if (mode === MODE_ACTIVE) {
      radius = Math.pow(2, circleRadius / MAX_CIRCLE_RADIUS) * CIRCLE_UNFOCUSED_RADIUS;
    }
    else if (mode === MODE_HIDDEN) {
      radius = 0;
    }

    lengthA = radius / 2 + randomRange(-2, 2);
    lengthB = radius / 2 + randomRange(-2, 2);
    const circleAngle = Math.PI * 2 * index / 4;

    positionOffset = radius / 20 + 5;

    angle = anchor.angle;

    if (mode !== MODE_HIDDEN) {
      x = 0 + radius * Math.cos(circleAngle) + randomRange(-positionOffset, positionOffset);
      y = 0 + radius * Math.sin(circleAngle) + randomRange(-positionOffset, positionOffset);
    }
    else {
      x = 0;
      y = 0;
      lengthA = 0;
      lengthB = 0;
    }
    return {
      ...anchor,
      angle, // tangent
      lengthA,
      lengthB,
      x: x,
      y: y,
    };
  }

  onResize = (e) => {
    const el = this.refs.blobs;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    this.windowWidth = window.innerWidth;

    this.app.renderer.resize(width, height);
    this.blobPosition.y = height / 2;

    if (this.windowWidth < DESKTOP_BP && this.state.activeSection !== null) {
      this.blobPosition.y = 70;
    }

    this.moveBlobs();
    // const x = this.state.activeSection ? width / 4 : width / 2;
    // const y = height / 2;

    // _map(this.circles, circle => {
    //   circle.blob.moveTo(x, y);
    // });
  }

  render() {
    const { activeSection, areLabelsVisible } = this.state;
    let content = <>
      <p>One of the benefits of design thinking is its scalability.</p>
      <p>Whether you’re working by <b>yourself</b>, in a <b>team</b>, or working for a better future for <b>all</b>, Design Thinking provides a framework to facilitate creativity and innovation.</p>
    </>;
    let title = null;
    if (activeSection != null) {
      const section = this.circles[activeSection];
      content = section.content;
      title = section.label;
    }

    const labels = this.createLabels();
    return (
      <div className="WhereSlide2" { ...wobblyLineProps({ color: this.props.color }) }>
        <div className="WhereSlide2-blobs">
          <div ref="blobs" className="WhereSlide2-blobCanvas"/>
          <div className={`WhereSlide2-labels ${areLabelsVisible ? 'WhereSlide2-labels--show' : ''}`}>
            {labels}
          </div>
        </div>
        <div className={`Page-content ${activeSection != null ? 'Page-content--show': ''}`}>
          <Content title={title} resetBlobs={e => this.resetBlobs()}>{content}</Content>
        </div>
      </div>
    );
  }
}

class Content extends Component {
  constructor() {
    super();

    this.state = {
      children: null
    }
  }

  shouldComponentUpdate(props) {
    return (this.props.title !== props.title);
  }

  componentWillReceiveProps(props) {
    if (this.props.title === props.title) return;

    if (window.innerWidth >= DESKTOP_BP) return;

    this.refs.content.style.opacity = 0;
    this.refs.oldContent.style.opacity = 1;

    let contentTargets = { opacity: 0 };

    anime({
      targets: contentTargets,
      opacity: [0, 1],
      duration: 900,
      easing: 'easeOutSine',
      update: (anim) => {
        if (!this.refs.content) return;
        this.refs.content.style.opacity = contentTargets.opacity;
      }
    });

    const oldContentTargets = { opacity: 1 };
    anime({
      targets: oldContentTargets,
      opacity: 0,
      duration: 900,
      easing: 'easeOutSine',
      update: (anim) => {
        if (!this.refs.oldContent) return;
        this.refs.oldContent.style.opacity = oldContentTargets.opacity;
      }
    });

    this.setState({
      isAnimating: true,
      children: this.props.children, // previous children
    });
  }

  render() {
    return (
      <>
          <div className="Blob-reset" onClick={()=>this.props.resetBlobs()}>
            <ReactSVG src="./assets/arrow-back.svg"  />
          </div>
          <div className="WhereSlide2-sectionContent" ref="content">
            {this.props.children}
          </div>
          <div className="WhereSlide2-sectionOldContent" ref="oldContent">
            {this.state.children}
          </div>
      </>
    )
  }
}
